var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWrite28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.06 4.06a1.5 1.5 0 0 0-2.12-2.12l-11 11a1.5 1.5 0 0 0 2.12 2.12l11-11Zm-8.878 13.122 7.762-7.762c.056 1.1.056 2.386.056 3.918v3.604c0 3.169 0 4.753-1.067 5.904-1.068 1.15-2.523 1.26-5.435 1.48A60.2 60.2 0 0 1 14 24.5a60.2 60.2 0 0 1-4.498-.174c-2.912-.22-4.367-.33-5.435-1.48C3 21.696 3 20.111 3 16.942v-3.604C3 8.547 3 6.15 4.711 4.402c1.711-1.75 3.83-1.796 8.066-1.888a55.807 55.807 0 0 1 2.446 0c1.483.032 2.707.059 3.744.155l-8.149 8.149a4.5 4.5 0 0 0 6.364 6.364Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrite28);
export default __webpack_public_path__ + "static/media/write_28.4726d8d1.svg";
export { ForwardRef as ReactComponent };